import type { ComponentProps } from 'react'

import ProductCardV3 from '../ProductCardV3/ProductCardV3'

type ProductCardProps = ComponentProps<typeof ProductCardV3>

export default function ProductCard(props: ProductCardProps) {
  const Component = ProductCardV3

  return <Component {...props} />
}
